export default "__VITE_ASSET__BOVCkBIl__"